// TrainerLayout.js
import React, { useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import TrainerSidebar from './TrainerSidebar';
import MobileTrainerSidebar from './MobileTrainerSidebar';
import '../../styles/TrainerLayout.css';
import { TrainerContext } from "../../context/TrainerContext";
import TopNavBar from '../commons/TopNavBar';

const TrainerLayout = ({ children }) => {
    const { trainer } = useContext(TrainerContext);
    const location = useLocation();

    // Initialize state from localStorage or default to false
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
        const saved = localStorage.getItem('trainerSidebarCollapsed');
        return saved !== null ? JSON.parse(saved) : false;
    });

    // Save state to localStorage whenever it changes
    useEffect(() => {
        localStorage.setItem('trainerSidebarCollapsed', JSON.stringify(isSidebarCollapsed));
    }, [isSidebarCollapsed]);

    const toggleSidebarCollapse = () => {
        setIsSidebarCollapsed(!isSidebarCollapsed);
    };

    return (
        <div className={`layout-container ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
            {/* The desktop sidebar (hidden on small screens by CSS) */}
            <div className="sidebar">
                <TrainerSidebar
                    trainer={trainer}
                    isCollapsed={isSidebarCollapsed}
                    onToggleCollapse={toggleSidebarCollapse}
                    activeRoute={location.pathname}
                />
            </div>

            {/* Mobile sidebar - the toggle button is now in TopNavBar */}
            <div className="mobile-sidebar-container">
                <MobileTrainerSidebar />
            </div>

            <div className="content">
                <TopNavBar pageTitle="Dashboard" userId={trainer?.id} />
                {children}
            </div>
        </div>
    );
};

export default TrainerLayout;